import React from 'react';

import IconButton from 'components/common/IconButton';

import BulkActions from './BulkActions';
import Actions from './Actions';

const ActionsSection = ({ selectedRowIds, handleShow, handleOpen, handleLoad }) => (
    <div className="d-flex align-items-center justify-content-between justify-content-lg-end px-x1">
        <IconButton
            variant="falcon-default"
            size="sm"
            icon="filter"
            transform="shrink-4"
            iconAlign="middle"
            onClick={handleShow}
            className="d-xl-none"
        >
            <span className="d-none d-sm-inline-block ms-1">Filter</span>
        </IconButton>
        <div className="bg-300 mx-3 d-none d-lg-block d-xl-none" style={{ width: '1px', height: '29px' }}></div>
        {Object.keys(selectedRowIds).length > 0 ? (
            <BulkActions />
        ) : (
            <Actions handleOpen={handleOpen} handleLoad={handleLoad} />
        )}
    </div>
);

export default ActionsSection;